import './styles/index.css';
// Side-effect import — bootstraps i18next before any component mounts.
import './lib/i18n';

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';

import { App } from './App';
import { initAnalytics } from './lib/analytics';
import { queryClient } from './lib/query-client';
import { initSentry } from './lib/sentry';

// Initialise Sentry before anything renders so early errors are captured.
initSentry();
initAnalytics();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  </StrictMode>,
);
